import { axiosInstance as axios } from 'Api';
import { handlingResponse } from 'Utility/globalMethods';
import { Config } from 'Constants/config_env';
/* eslint-disable global-require */
if (ISMOCK) {
	require('Mocks/store/store');
}

export async function createStore(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/create`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function deleteStore(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/delete`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function detailStore(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/detail`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function findStore(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/find`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function listStores(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/list`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function updateStore(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `store/update`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
// @generator api:method
